import client from './client';

export const usersApi = {
  // Profile
  getProfile: () => client.get('/auth/me'),
  updateProfile: (data) => client.put('/users/profile', data),

  // User management (admin)
  getAll: () => client.get('/users'),
  getById: (userId) => client.get(`/users/${userId}`),
  create: (data) => client.post('/users', data),
  update: (userId, data) => client.put(`/users/${userId}`, data),
  delete: (userId) => client.delete(`/users/${userId}`),

  // Coaches
  getCoaches: () => client.get('/users/coaches'),

  // Clients
  getMyClients: () => client.get('/users/my-clients'),

  // Diet targets
  updateDiet: (userId, data) => client.put(`/users/${userId}/diet`, data),

  // Onboarding
  completeOnboarding: (data) => client.put('/users/onboarding', data),

  // Preferences
  updatePreferences: (data) => client.put('/users/preferences', data),

  // Routine assignment
  assignRoutine: (userId, routineId) =>
    client.put(`/users/${userId}/routine`, { routine_id: routineId }),
};
